import CaretDownOutlined from '@ant-design/icons/CaretDownOutlined'
import useVisible from '@shared/innmaxLib/hooks/useVisible'
import { Dropdown } from '@shared/innmaxUI/Dropdown'
import Button from '@shared/innmaxUI/Form/Button'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import ColumnSettingsModal from './ColumnSettingsModal'
import MarkerGuideModal from './MarkerGuideModal'

const MapSettingDropdown = (props: { lastUpdated: moment.Moment }) => {
  const { t } = useTranslation()

  const { lastUpdated } = props

  const { visible: columnSettingsVisible, toggle: columnSettingsToggle } =
    useVisible()

  const { visible: markerModalVisible, toggle: markerModalToggle } =
    useVisible()

  return (
    <>
      <Dropdown
        menu={[
          {
            key: 'settings',
            label: t('dashboard:set device fields for showing'),
            onClick: columnSettingsToggle,
          },
          {
            key: 'marker',
            label: t('dashboard:marker explanation'),
            onClick: markerModalToggle,
          },
        ]}>
        <DropdownButton
          shape="round"
          type="primary"
          ghost
          className="ant-dropdown-link p-0">
          <div>
            {t('dashboard:map settings')}
            <CaretDownOutlined className="icon-caret-down" />
          </div>
        </DropdownButton>
      </Dropdown>
      <LastUpdated>
        {t('dashboard:last updated')}：{lastUpdated.format('YYYY/MM/DD HH:mm')}
      </LastUpdated>
      <ColumnSettingsModal
        visible={columnSettingsVisible}
        onCancel={columnSettingsToggle}
        updateSuccessful={columnSettingsToggle}
      />
      <MarkerGuideModal
        visible={markerModalVisible}
        onCancel={markerModalToggle}
      />
    </>
  )
}

export default MapSettingDropdown

const LastUpdated = styled.div`
  color: ${({ theme }) => theme.n.gray300};
  margin-right: 30px;
  font-size: 12px;

  @media only screen and (min-width: 1200px) {
    margin-right: 35px;
  }
`

const DropdownButton = styled(Button)`
  margin-right: 30px;
  height: auto;
  box-shadow: none !important;

  > div {
    font-size: 14px;
    font-weight: normal;
    margin: 0 15px;
    display: flex;
    align-items: center;

    .icon-caret-down {
      position: relative;
      margin-left: 5px !important;
      font-size: 14px !important;

      svg {
        width: 12px;
        height: 12px;
      }
    }
  }

  @media only screen and (min-width: 1200px) {
    margin-right: 35px;
  }
`
